import { IFormSection } from 'pages/revisions-module/template-editor/editors/form/types';
import type { DeviceMeasurementsPlaceholderColumn } from 'pages/revisions-module/template-editor/editors/template/extensions/placeholder/device-measurements/DeviceMeasurementsPlaceholder';

export const DEVICE_MEASUREMENTS_LAST_LOCKED_AT_COLUMN_KEY = '_lastLockedAt';
export const DEVICE_MEASUREMENTS_LAST_UNLOCKED_AT_COLUMN_KEY = '_lastUnlockedAt';
export const DEVICE_MEASUREMENTS_DATE_TIME_COLUMN_TYPE = 'dateTime';

/**
 * Builds the list of placeholder columns for a measurement section, including row-lock metadata when enabled.
 */
export function getDeviceMeasurementsPlaceholderColumns(section?: IFormSection): DeviceMeasurementsPlaceholderColumn[] {
  if (!section) {
    return [];
  }

  const measurementColumns = section.rows
    .filter(({ inputs }) => inputs.length > 0)
    .map(({ inputs: [{ spec }] }) => ({
      key: spec.name,
      label: spec.label || spec.name,
      type: spec.type,
      suffix: spec.type === 'number' ? spec.suffix : undefined,
      precision: spec.type === 'number' ? spec.precision ?? 0 : undefined,
    }));

  if (!section.measurementsAllowRowLocking) {
    return measurementColumns;
  }

  return [
    ...measurementColumns,
    {
      key: DEVICE_MEASUREMENTS_LAST_LOCKED_AT_COLUMN_KEY,
      label: 'Naposledy uzamknuté',
      type: DEVICE_MEASUREMENTS_DATE_TIME_COLUMN_TYPE,
    },
    {
      key: DEVICE_MEASUREMENTS_LAST_UNLOCKED_AT_COLUMN_KEY,
      label: 'Naposledy odomknuté',
      type: DEVICE_MEASUREMENTS_DATE_TIME_COLUMN_TYPE,
    },
  ];
}
